// extracted by mini-css-extract-plugin
module.exports = {"dpu-new1":"NEW1Us_dpu-new1__CFIQQ"};